export const ZONE_FALLBACK_COLOR = '#9CA3AF';
export const ZONE_FILL_OPACITY = 0.22;
export const ZONE_WEIGHT = 1.5;
export const SELECTED_ZONE_FILL_OPACITY = 0.45;
export const SELECTED_ZONE_WEIGHT = 3;

const normalizeHex = (color: string): string => {
  const s = (color || '').trim();
  if (!s) return '';
  if (s.startsWith('#')) return s.toUpperCase();
  if (/^[0-9A-Fa-f]{6}$/.test(s)) return `#${s.toUpperCase()}`;
  return s;
};

const isBlankOrWhite = (hex: string): boolean => {
  if (!hex) return true;
  const upper = hex.toUpperCase();
  return upper === '#FFFFFF' || upper === '#FFF';
};

export function getZoneDisplayColor(zone: {
  color?: string | null;
}): string {
  const z = zone as {
    color?: string | null;
    colour?: string;
    Color?: string;
  };
  const raw = z.color ?? z.colour ?? z.Color ?? '';
  const normalized = normalizeHex(typeof raw === 'string' ? raw : '');
  if (isBlankOrWhite(normalized)) return ZONE_FALLBACK_COLOR;
  return normalized;
}
